import React from 'react';
import styled from 'styled-components/macro';
import { StoreFilterOptionsHeaderProps } from '../types/StoreFilterOptionsHeaderProps';

const UnstyledStoreFilterOptionsHeader: React.FC<
  StoreFilterOptionsHeaderProps
> = ({ className, children, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <span>{children}</span>
      <i className="icon-right-open"></i>
    </div>
  );
};

const StoreFilterOptionsHeader = styled(UnstyledStoreFilterOptionsHeader)`
  align-items: center;
  border-bottom: 0.071em solid var(--gray-2);
  border-top: 0.143em solid var(--gray-2);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 1.077em;
  font-weight: bold;
  height: 3.429em;
  padding: 0 1.071em;

  span {
    flex: auto;
  }

  i {
    color: var(--gray-3);
    flex: none;
    font-size: 0.929em;
    transform: rotate(-90deg);
    transition: all 200ms ease-out;
    margin-top: ${(props) => (props.close ? '0.25em' : 0)};
    transform: ${(props) => (props.close ? 'rotate(90deg)' : 'rotate(-90deg)')};
  }
`;

export default StoreFilterOptionsHeader;
